import { useState, useEffect, useCallback } from 'react';
import { car as carApi } from '../../utils/api';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export const useCarControllers = () => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { t } = useTranslation();

  const fetchCars = useCallback(async () => {
    try {
      setLoading(true);
      const cars = await carApi.getUserCars();
      setCars(cars);
    } catch (error) {
      toast.error(t('cars.messages.error'));
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    fetchCars();
  }, [fetchCars]);

  const closeModals = () => {
    setIsAddModalOpen(false);
    setIsEditModalOpen(false);
    setIsDeleteModalOpen(false);
    setSelectedCar(null);
  };

  const openAddModal = () => {
    setIsAddModalOpen(true);
  };

  const openEditModal = (car) => {
    setSelectedCar(car);
    setIsEditModalOpen(true);
  };

  const openDeleteModal = (car) => {
    setSelectedCar(car);
    setIsDeleteModalOpen(true);
  };

  const handleAddCar = async (data) => {
    try {
      setLoading(true);
      await carApi.create(data);
      await fetchCars();
      closeModals();
      toast.success(t('cars.messages.addSuccess'));
    } catch (error) {
      toast.error(t('cars.messages.error'));
    } finally {
      setLoading(false);
    }
  };

  const handleEditCar = async (data) => {
    try {
      setLoading(true);
      await carApi.update(selectedCar._id, data);
      await fetchCars();
      closeModals();
      toast.success(t('cars.messages.updateSuccess'));
    } catch (error) {
      toast.error(t('cars.messages.error'));
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCar = async (carId) => {
    try {
      setLoading(true);
      await carApi.delete(carId);
      await fetchCars();
      closeModals();
      toast.success(t('cars.messages.deleteSuccess'));
    } catch (error) {
      toast.error(t('cars.messages.error'));
    } finally {
      setLoading(false);
    }
  };

  return {
    cars,
    loading,
    selectedCar,
    isAddModalOpen,
    isEditModalOpen,
    isDeleteModalOpen,
    handleAddCar,
    handleEditCar,
    handleDeleteCar,
    openAddModal,
    openEditModal,
    openDeleteModal,
    closeModals
  };
}; 